// Enum values matching backend
export enum BanLevel {
  NO_SAVE = 1,
  NO_GENERATE = 2,
  SITE_WIDE = 3,
}
